import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@mui/material";
import {
  deleteBlogFilesByIdRequest,
  getBlogByIdRequest,
  updateBlogByIdRequest,
} from "api/blogs";
import UploadCm from "components/AdvsUploadCm";
import BackButton from "components/shared/BackButton";
import DrawerCM from "components/shared/Drawer";
import EditorCm from "components/shared/EditorCm";
import LoadingCM from "components/shared/Loading";
import ProgressBarCM from "components/shared/ProgressBar";
import StackCm from "components/shared/StackCm";
import TextFieldCm from "components/shared/TextField";
import { categoriesData } from "constants/category";
import Toast from "helper/toast";
import useHttp from "hooks/use-http";
import React, { useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { StyledGlBtn } from "styles/globals";
import blogsSchema from "validations/blogs";

const INPUTS = [
  {
    id: "title",
    label: "عنوان",
  },
  {
    id: "time",
    label: "زمان مورد نیاز",
  },
  {
    id: "blog_category_id",
    label: "محله",
    selectItems: categoriesData,
    type: "select",
  },
];

export default function EditBlog() {
  const { id } = useParams();
  const {
    register,
    handleSubmit,
    reset,
    control,
    watch,
    formState: { errors },
  } = useForm({ resolver: yupResolver(blogsSchema) });

  const { request, loading, isUploading, setUploadProgress, uploadProgress } =
    useHttp(false);

  // editor value
  const [text, setText] = useState("");
  const [image, setImage] = useState("");

  const deleteFile = (data) => {
    const res = request({
      url: deleteBlogFilesByIdRequest,
      values: {
        id,
        ...data,
      },
    });
    if (res) {
      getDataById();
    }
  };
  const onSubmit = async (data) => {
    const res = await request({
      url: () =>
        updateBlogByIdRequest(
          {
            ...data,
            id,
            description: text,
            image: image?.isWeb ? null : image?.url,
          },
          (progress) => setUploadProgress(progress)
        ),
      isFile: true,
    });

    if (res) {
      Toast({ type: "success", title: "ویرایش وبلاگ" });
      reset();
      getDataById();
    }
  };

  const getDataById = async () => {
    const res = await request({
      url: getBlogByIdRequest,
      values: { id },
    });
    if (res) {
      reset({
        title: res?.title ?? "test",
        time: res?.time ?? 2,
        alt: res?.image?.alt ?? "",
        blog_category_id: res?.blog_category_id ?? "",
        blog_subcategory_id: res?.blog_subcategory_id ?? "",
        keyword: res?.seo_options?.keyword ?? "",
        meta_description: res?.seo_options?.meta_description ?? "",
      });
      setImage({
        isChanged: Boolean(res?.image?.url),
        url: res?.image?.url || null,
        isWeb: true,
      });
      setText(res.description || "");
    }
  };

  useEffect(() => {
    getDataById();
  }, []);

  return (
    <DrawerCM title="ویرایش وبلاگ">
      <Grid item xs={12} mt={3}>
        <BackButton />
      </Grid>
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <StackCm title="فیلد های وبلاگ">
          <Grid container>
            {INPUTS.map((input) => (
              <Grid key={input.id} item md={4} sm={6} xs={12} p={1.5}>
                <TextFieldCm
                  {...input}
                  register={register}
                  errors={errors}
                  control={control}
                />
              </Grid>
            ))}

            <Grid item md={4} sm={6} xs={12} p={1.5}>
              <TextFieldCm
                id={"blog_subcategory_id"}
                type={"select"}
                label={"زیردسته"}
                selectItems={
                  watch("blog_category_id") == 1
                    ? categoriesData[0].subCategories
                    : []
                }
                register={register}
                errors={errors}
                control={control}
              />
            </Grid>
            <Grid item md={12} xs={12} p={1.5}>
              <UploadCm
                title={"بارگزاری عکس وبلاگ"}
                id={"image"}
                state={image}
                setState={setImage}
                handleDeleteReq={() => deleteFile({ image: null })}
              />
            </Grid>
            <Grid item xs={12} p={1.5}>
              <TextFieldCm
                id={"alt"}
                label={"متن جایگزین (alt)"}
                register={register}
                errors={errors}
              />
            </Grid>
            <Grid item xs={12} p={1.5}>
              <EditorCm state={text} setState={setText} />
            </Grid>
            {[
              {
                id: "keyword",
                label: "کلمات کلیدی (سئو)",
              },
              {
                id: "meta_description",
                label: "توضیحات (سئو)",
              },
            ].map((input) => (
              <Grid
                key={input.id}
                item
                md={input.id === "meta_description" ? 8 : 4}
                xs={12}
                p={1.5}
              >
                <TextFieldCm
                  {...input}
                  register={register}
                  errors={errors}
                  control={control}
                />
              </Grid>
            ))}
            <StyledGlBtn onClick={handleSubmit(onSubmit)} />
          </Grid>
        </StackCm>
      )}
    </DrawerCM>
  );
}
